const englishMessages = {
  ra: {
    action: {
      add_filter: "Add filter",
      add: "Add",
      back: "Go Back",
      bulk_actions: "1 item selected |||| %{smart_count} items selected",
      cancel: "Cancel",
      clear_array_input: "Clear the list",
      clear_input_value: "Clear value",
      clone: "Clone",
      confirm: "Confirm",
      create: "Create",
      create_item: "Create %{item}",
      delete: "Delete",
      edit: "Edit",
      export: "Export",
      list: "List",
      refresh: "Refresh",
      remove_filter: "Remove this filter",
      remove_all_filters: "Remove all filters",
      remove: "Remove",
      save: "Save",
      search: "Search",
      select_all: "Select all",
      select_row: "Select this row",
      show: "Show",
      sort: "Sort",
      undo: "Undo",
      unselect: "Unselect",
      expand: "Expand",
      close: "Close",
      open_menu: "Open menu",
      close_menu: "Close menu",
      update: "Update",
      move_up: "Move up",
      move_down: "Move down",
      open: "Open",
      toggle_theme: "Toggle Theme",
      select_columns: "Columns",
    },
    boolean: {
      true: "Yes",
      false: "No",
      null: " ",
    },
    page: {
      create: "Create %{name}",
      dashboard: "Dashboard",
      edit: "%{name} #%{id}",
      error: "Something went wrong",
      list: "%{name}",
      loading: "Loading",
      not_found: "Not Found",
      show: "%{name} #%{id}",
      empty: "No data available",
      invite: "",
    },
    input: {
      file: {
        upload_several: "Drop some files to upload, or click to select one.",
        upload_single: "Drop a file to upload, or click to select it.",
      },
      image: {
        upload_several: "Drop some pictures to upload, or click to select one.",
        upload_single: "Drop a picture to upload, or click to select it.",
      },
      references: {
        all_missing: "Unable to find references data.",
        many_missing:
          "At least one of the associated references no longer appears to be available.",
        single_missing:
          "Associated reference no longer appears to be available.",
      },
      password: {
        toggle_visible: "Hide password",
        toggle_hidden: "Show password",
      },
    },
    message: {
      about: "About",
      are_you_sure: "Are you sure?",
      bulk_delete_content:
        "Are you sure you want to delete this %{name}? |||| Are you sure you want to delete these %{smart_count} items?",
      bulk_delete_title: "Delete %{name} |||| Delete %{smart_count} %{name}",
      auth_error:
        "An error occurred while validating the authentication token.",
      bulk_delete_content:
        "Are you sure you want to delete this %{name}? |||| Are you sure you want to delete these %{smart_count} items?",
      bulk_delete_title: "Delete %{name} |||| Delete %{smart_count} %{name}",
      bulk_update_content:
        "Are you sure you want to update this %{name}? |||| Are you sure you want to update these %{smart_count} items?",
      bulk_update_title: "Update %{name} |||| Update %{smart_count} %{name}",
      clear_array_input: "Are you sure you want to clear the whole list?",
      delete_content: "Are you sure you want to delete this item?",
      delete_title: "Delete %{name} #%{id}",
      details: "Details",
      error: "A client error occurred and your request couldn't be completed.",

      invalid_form: "The form is not valid. Please check for errors",
      loading: "The page is loading, just a moment please",
      no: "No",
      not_found: "Either you typed a wrong URL, or you followed a bad link.",
      yes: "Yes",
      unsaved_changes:
        "Some of your changes weren't saved. Are you sure you want to ignore them?",
    },
    navigation: {
      no_results: "No results found",
      no_more_results:
        "The page number %{page} is out of boundaries. Try the previous page.",
      page_out_of_boundaries: "Page number %{page} out of boundaries",
      page_out_from_end: "Cannot go after last page",
      page_out_from_begin: "Cannot go before page 1",
      page_range_info: "%{offsetBegin}-%{offsetEnd} of %{total}",
      page_rows_per_page: "Rows per page:",
      next: "Next",
      prev: "Prev",
      partial_page_range_info:
        "%{offsetBegin}-%{offsetEnd} of more than %{offsetEnd}",
      current_page: "Page %{page}",
      page: "Go to page %{page}",
      first: "Go to first page",
      last: "Go to last page",
      next: "Go to next page",
      previous: "Go to previous page",
      page_rows_per_page: "Rows per page:",
      skip_nav: "Skip to content",
    },
    sort: {
      sort_by: "Sort by %{field} %{order}",
      ASC: "ascending",
      DESC: "descending",
    },
    auth: {
      auth_check_error: "Please login to continue",
      user_menu: "Profile",
      username: "Username",
      password: "Password",
      sign_in: "Sign in",
      sign_in_error: "Authentication failed, please retry",
      logout: "Logout",
    },
    notification: {
      updated: "Element updated |||| %{smart_count} elements updated",
      created: "Element created",
      deleted: "Element deleted |||| %{smart_count} elements deleted",
      bad_item: "Incorrect element",
      item_doesnt_exist: "Element does not exist",
      http_error: "Server communication error",
      data_provider_error: "dataProvider error. Check the console for details.",
      i18n_error: "Cannot load the translations for the specified language",
      canceled: "Action cancelled",
      logged_out: "Your session has ended, please reconnect.",
      not_authorized: "You're not authorized to access this resource.",
    },
    validation: {
      required: "Required",
      minLength: "Must be %{min} characters at least",
      maxLength: "Must be %{max} characters or less",
      minValue: "Must be at least %{min}",
      maxValue: "Must be %{max} or less",
      number: "Must be a number",
      email: "Must be a valid email",
      oneOf: "Must be one of: %{options}",
      regex: "Must match a specific format (regexp): %{pattern}",
    },
    saved_queries: {
      label: "Saved queries",
      query_name: "Query name",
      new_label: "Save current query...",
      new_dialog_title: "Save current query as",
      remove_label: "Remove saved query",
      remove_label_with_name: 'Remove query "%{name}"',
      remove_dialog_title: "Remove saved query?",
      remove_message:
        "Are you sure you want to remove that item from your list of saved queries?",
      help: "Filter the list and save this query for later",
    },
    configurable: {
      customize: "Customize",
      configureMode: "Configure this page",
      inspector: {
        title: "Inspector",
        content: "Hover the application UI elements to configure them",
        reset: "Reset Settings",
        hideAll: "Hide All",
        showAll: "Show All",
      },
      Datagrid: {
        title: "Datagrid",
        unlabeled: "Unlabeled column #%{column}",
      },
      SimpleForm: {
        title: "Form",
        unlabeled: "Unlabeled input #%{input}",
      },
      SimpleList: {
        title: "List",
        primaryText: "Primary text",
        secondaryText: "Secondary text",
        tertiaryText: "Tertiary text",
      },
    },
  },
  language: {
    demoText: "demo text here for language switch",
  },
  resources: {
    // sap_digital_app_orders: {
    //     fields: {
    //         truck_number: "Truck & driver details"
    //     }
    // },
    sap_digital_orders: {
      fields: {
        truck_number: "Truck & driver details",
      },
    },
    // sap_digital_disputed_orders: {
    //     fields: {
    //         truck_number: "Truck & driver details"
    //     }
    // },
    // sap_sdo_for_orders: {
    //     fields: {
    //         truck_plate_no: "Truck Plate No."
    //     }
    // },
    productsmaster: {
      fields: {
        edit: "Edit",
        updated_at: "Upload Timestamp",
        image_data: "Uploaded Image",
        name: "Name",
        material_code: "Material Code",
        material_description: "Material Description",
        title: "Product Images",
        product_name: "Product name",
        product_desc: "Product Description",
        updated_at: "Upload Timestamp",
        product_master: "Product Name",
        upload_images: "Upload Images",
        instruction: "Instructions: ",
        allowed_type:
          "Allowed file types: Images: JPG Image, JPEG Image, PNG Image",
        max_size: "Max file size (total): 1 MB",
        pixel:
          "The image should be 345 pixels in width & 345 pixels in height with white background color",
        product_content:
          "The product content image should be 245 pixels in width & 245 pixels in height and it should be in center both horizontally and vertically",
        image_repr: "Image Representation",
        list_image: "List Image",
        front_image: "Front Image",
        back_image: "Back Image",
        side_image: "Side Image",
        image_dim:
          "Please select image with dimensions as 345 pixels in width & 345 pixels in height",
        img_size: "Please select image with size less than 1 MB",
        select_image: "Please select image png , jpg or jpeg",
        cropped_img: "Cropped Image",
        loading: "loading",
        save: "Save",
        product_images: "Product Images",
        product_images_edit: "Product images Edit",
      },
    },
    whitelist_users: {
      fields: {
        username: "Name",
        email: "Email",
        role_description: "Role",
        status: "Status",
        created_at: "Access Created At",
        updated_log: "Update Logs",
        edit: "Edit",
        business_mail: "Employee business email",
        view: "View",
        whitelist_user: "Whitelist users",
        email_search: "Search by email..",
        name_search: "Search by name..",
        status_search: "Search by status..",
        enter_email: "Enter email with Lafarge Holcim business suite.",
        customer_service: "Customer Service",
        country_admin: "Country Admin",
        country_super_admin: "Country Super admin",
        marketing: "Marketing",
        internal_control: "Internal Control",
      },
    },
    terms_and_condition_list: {
      fields: {
        language_name: "Language name",
        country: "Country",
        created_date: "created date",
        updated_log: "Updated Log",
        edit: "Edit",
        terms: "Terms and Conditions List",
        terms_logs: "Terms And Conditions logs",
        terms_condition: "Terms & Conditions",
        save: "Save",

        instruction: "Instruction :",
        instruction_desc:
          "Please copy and paste or enter the terms and conditions text and click on Save at the bottom.After Saving, please take a note of the spinner at the top right to see if text has been saved successfully.If the spinning has stopped and there's no error on screen, then text has been saved,else there would be an error message on the screen.",
      },
    },
    businesses: {
      fields: {
        name: "Name",
        sap_code: "Sold To ID",
        users_count: "Clickit Users",
        users_count_holcim: "HOLCIM+ Users",
        projects_count: "Contracts",
        is_ordering_blocked: "Ordering Blocked",
        profile_details: "PROFILE DETAILS",
        orders: "ORDERS",
        clickit_user: "CLICKIT USERS",
        holcim_user: "HOLCIM+ USERS",
        projects: "PROJECTS",
        create_user: "Create User",
        export: "Export",
        project_number: "Project Number",
        project_title: "Title",
        project_address: "Address",
        op_division: "Op division",
        status: "Status",
        phone: "Phone",
        email: "Email",
        role_name: "Role name",
        contract: "CONTRACT",
        contracts: "CONTRACTS",
      },
    },
    users_list: {
      fields: {
        first_name: "First name",
        last_name: "Last name",
        phone: "Phone",
        email: "Email",
        principle_name: "Sold To Name",
        principle_id: "Sold To ID",
        role_name: "Role name",
        created_at: "Created at",
        status: "Status",
      },
    },
    projects: {
      fields: {
        project_number: "Project Number",
        project_title: "Title",
        project_address: "Address",
        op_division: "Op division",
        status: "Status",
      },
    },
    users: {
      fields: {
        first_name: "First name",
        last_name: "Last name",
        phone: "Phone",
        email: "Email",
        principle_name: "Sold To Name",
        principle_id: "Sold To ID",
        role_name: "Role name",
        created_at: "Created at",
        status: "Status",
        address: "address",
        profile_image_data: "Profile",
        is_tnc_accepted: "Tnc Accepted",
        is_super: "super",
        updated_at: "Updated at",
        updated_by_id: "Updated by",
        sold_to: "Sold To",
        business_id: "Sold To",
        save: "Save",
        clear: "Clear",
        export: "Export",
        clickit_user: "User List",
        create_user: "Create User",
        user_test: "User",
        edit_user: "Edit User",
        user_details: "User Details",
        sold_to: "Sold To",
        orders: "Orders",
        userEntity: "User Entity Mapping Status",
        tnc_accepted: "Tnc accepted at",
        tnc_rejected: "Tnc rejected at",
        role: "Role",
        contract: "Contract",
        contracts: "Contracts",
        create_loyalty_points: "Create Loyalty Points",
        loyalty_points: "Loyalty Points",
      },
    },
    sms_blasts: {
      fields: {
        purpose: "Purpose",
        text: "Sms text",
        target_type: "Target type",
        created_at: "Created at",
        sms_length: "SMS length [eg. 2 (160 characters)]",
        targeted_businesses_count: "Number of Sold tos",
        number_of_messages: "Number of SMS (Number of Sold tos * SMS length)",
        notified_businesses_count: "Number of SMS sent successfully",
        failed_businesses: "Number of SMS sending failed",
        id: "Sold To ID",
        name: "Sold To Name",
        phone: "Sold To Phone",
        send_status: "SMS status",
        send_response: "SMS response",
        message_purpose: "Message Purpose",
        enter_purpose: "Please enter a Purpose",
        message_desc: "Message Description",
        enter_desc: "Please enter a description",
        char_remaining: "characters remaining",
        sms_count: "Sms count:",
        msg_sendto: "Message Send To",
        all_retailer: "All Retailers",
        set_retailer: "A set of Retailers",
        sales_officer: "Sales Officers of Retailers",
        region_retailer: "Regions of Retailers",
        customer_group: "Customer Group of Retailers",
        choose_officer: "Choose Sales Officer",
        atleast_one: "Atleast select one sales officer",
        clear: "Clear",
        choose_retailer: "Choose Retailer",
        atleast_one_retailer: "Atleast select one retailer",
        choose_region: "Choose Region",
        atleast_one_region: "Atleast select one region",
        choose_customer: "Choose Customer Group",
        atleast_one_group: "Atleast select one Group",
        choose_customer_retailer: "Choose Customer Retailer",
        upload_file: "Upload File",
        instruction: "Instructions :",
        only_csv: "Only CSV files are allowed with Comma as separator.",
        file_format: "To get upload file format.",
        click_here: "Click here",
        to_download: "to download",
        csv_result: "CSV Result",
        retailer_found: "retailers found,",
        retailer_unregister: "retailers unregistered.",
        total_cost: "total cost: ",
        save: "Save",
        are_you_sure: "Are you sure, you want to proceed ?",
        cancel: "Cancel",
        ok: "Ok",
        success: "Successfully Created",
        send_msg: "Send Message",
        target_type: "Target type",
        from_date: "From date",
        to_date: "To date",
      },
    },

    in_app_notifications: {
      fields: {
        purpose: "Purpose",
        title: "Title",
        type: "Type",
        job_status: "Notification Progress",
        admin_name: "Creator Name",
        admin_email: "Creator Email",
        created_at: "Created at",
        description: "Description",
        targeted_businesses_count: "Count of targeted retailers",
        notified_businesses_count: "Count of retailers notified",
        notification_read_count: "Count of retailers who have read",
        send_status_percent: "Completion %",
        noti_purpose: "Notification Purpose",
        enter_purpose: "Please enter a Purpose",
        noti_title: "Notification Title",
        enter_title: "Please enter a title",
        noti_desc: "Notification Description",
        enter_desc: "Please enter a description",
        char_remaining: "characters remaining",
        all_retailer: "All Retailers",
        set_retailer: "A set of Retailers",
        send_to: "Notification Send To",
        sales_officer: "Sales Officers of Retailers",
        region_retailer: "Regions of Retailers",
        customer_group: "Customer Group of Retailers",
        choose_officer: "Choose Sales Officer",
        atleast_one: "Atleast select one sales officer",
        clear: "Clear",
        choose_retailer: "Choose Retailer",
        atleast_one_retailer: "Atleast select one retailer",
        choose_region: "Choose Region",
        atleast_one_region: "Atleast select one region",
        choose_customer: "Choose Customer Group",
        atleast_one_group: "Atleast select one Group",
        choose_customer_retailer: "Choose Customer Retailer",
        upload_file: "Upload File",
        instruction: "Instructions :",
        only_csv: "Only CSV files are allowed with Comma as separator.",
        file_format: "To get upload file format.",
        click_here: "Click here",
        to_download: "to download",
        csv_result: "CSV Result",
        retailer_found: "retailers found,",
        retailer_unregister: "retailers unregistered.",
        total_cost: "total cost :",
        save: "Save",
        are_you_sure: "Are you sure, you want to proceed ?",
        cancel: "Cancel",
        success: "Successfully Created",
        details: "DETAILS",
        sold_list: "SOLD TO LIST",
        target_type: "Target type",
        uploaded_date_from: "Uploaded date from",
        uploaded_date_to: "Uploaded date to",
      },
    },
    in_app_sold_to_list: {
      fields: {
        name: "Name",
        read_status: "Read Status",
        notification_sent_at: "Notification Sent At",
        send_status_percent: "Notification Status",
      },
    },
    plant: {
      fields: {
        name: "Asphalt Plant List",
      },
    },
    send_bulk_notifications: {
      fields: {
        purpose: "Purpose",
        title: "Title",
        type: "Type",
        job_status: "Notification Progress",
        admin_name: "Creator Name",
        admin_email: "Creator Email",
        created_at: "Created at",
        description: "Description",
        targeted_businesses_count: "Count of targeted retailers",
        notified_businesses_count: "Count of retailers notified",
        notification_read_count: "Count of retailers who have read",
        send_status_percent: "Completion %",
        details: "Details",
        sold_list: "SOLD TO LIST",
        noti_purpose: "Notification Purpose",
        enter_purpose: "Please enter a Purpose",
        upload_file: "Upload File",
        instruction: "Instructions :",
        only_csv: "Only CSV files are allowed with Comma as separator.",
        file_format: "To get upload file format.",
        click_here: "Click here",
        to_download: "to download",
        csv_result: "CSV Result",
        retailer_found: "retailers found,",
        retailer_unregister: "retailers unregistered.",
        valid_file: "rChoose Valid file",
        sold_to_id: "Sold To Id",
        name: "Name",
        title: "Title",
        save: "Save",
        success: "Successfully Created",
      },
    },
    bulk_notification_sold_to_list: {
      fields: {
        name: "Name",
        read_status: "Read Status",
        notification_sent_at: "Notification Sent At",
        send_status_percent: "Notification Status",
        title: "Title",
      },
    },
    complaints: {
      fields: {
        business_name: "Business Name",
        business_sap_code: "Sold To Id",
        user_id: "User name",
        complaint_type: "Record Type",
        complaint_number: "Record Number",
        category_name: "Category Name",
        subcategory_name: "Subcategory Name",
        complaint_status: "Record Status",
        complaint_created_at: "Record Created At",
        updated_at: "Resolution Timestamp",
        contact_us: "Contact Us",
        record_details: "Record details",
        ref_number: "Reference Number",
        created_at: "Created at",
        customer_desc: "Customer Description",
        customer_service: "Customer Service Comment",
        file_uploaded: "Files Uploaded",
        no_file_uploaded: "No files uploaded",
        pending_files:
          "File(s) selected while placing order are still being modified. Please check back here later",
        customer_files: "Customer Files Uploaded",
        customer_service_files: "Customer Service Files Uploaded",
        are_you_sure: "Are you sure you want to delete file ?",
        delete: "Delete",
        cancel: "Cancel",
        instruction: "Instructions :",
        allowed_type:
          "Allowed file types: Images: JPEG Image, PNG Image, Documents: PDF document, Microsoft Word document (.docx), Microsoft Excel (.xlsx), Comma Separated Values (.csv), OpenOffice Document (.odf), OpenOffice Spreadsheet (.ods)",
        max_size: "Max file size (total): 1 MB",
        please_wait:
          "Please wait till files are uploaded as closing the browser during upload will make the file upload process fail.",
        upload_timing:
          "Uploaded files may take up to 5 minutes to appear depending on the size.",
        upload_file: "Upload File",
        file_extension_invalid: "File extension is not valid",
        file_size: "File size is greater than 10 mb",
        file_type_invalid: "File type is not valid",
        both_invalid: "Both File size and type is not valid",
        edit_record: "Edit Record",
      },
    },
    clickit_products: {
      fields: {
        edit: "Edit",
        product_image: "Uploaded Image",
        product_name: "Product name",
        updated_at: "Upload Timestamp",
        product_master: "Product Name",
        upload_images: "Upload Images",
        instruction: "Instructions :",
        allowed_type:
          "Allowed file types: Images: JPG Image, JPEG Image, PNG Image",
        max_size: "Max file size (total): 1 MB",
        pixel:
          "The image should be 345 pixels in width & 345 pixels in height with white background color",
        product_content:
          "The product content image should be 245 pixels in width & 245 pixels in height and it should be in center both horizontally and vertically",
        image_repr: "Image Representation",
        list_image: "List Image",
        image_dim:
          "Please select image with dimensions as 345 pixels in width & 345 pixels in height",
        img_size: "Please select image with size less than 1 MB",
        select_image: "Please select image png , jpg or jpeg",
        cropped_img: "Cropped Image",
        save: "Save",
        loading: "loading",
        banner_img: "Banner Image",
        banner_select:
          "Please select image with dimensions as 750 pixels in width & 360 pixels in height",
        product_images: "Product Images",
        material_code: "Material code",
        name: "Name",
      },
    },
    dashboard_banners: {
      fields: {
        edit: "Edit",
        created_at: "Upload Timestamp",
        position: "Position",
        image_data: "Uploaded Image",
        status: "Status",
        mobile_home_banner: "Mobile Banners",
        web_home_banner: "Web Banners",
        banner_img: "Banner Image",
        banner_select:
          "Please select image with dimensions as 750 pixels in width & 360 pixels in height",
        banner_select_web:
          "Please select image with dimensions as 1071 pixels in width & 170 pixels in height",
        img_size: "Please select image with size less than 1 MB",
        select_image: "Please select image png , jpg or jpeg",
        instruction: "Instructions :",
        allowed_type:
          "Allowed file types: Images: JPG Image, JPEG Image, PNG Image",
        max_size: "Max file size (total): 1 MB",
        image_dim:
          "Please select image with dimensions as 750 pixels in width & 360 pixels in height",
        image_dim_web:
          "Please select image with dimensions as 1071 pixels in width & 170 pixels in height",
        cropped_img: "Cropped Image",
        save: "Save",
        loading: "loading",
        create_mobile_home_banner: "Create Mobile Banner",
        create_web_home_banner: "Create Web Banner",
        edit_mobile_home_banner: "Edit Mobile Banner",
        edit_web_home_banner: "Edit Web Banner",
      },
    },
    proof_of_payments: {
      fields: {
        created_at: "Upload Timestamp",
        business_id: "Sold To Id",
        sap_digital_order_id: "Order Number",
        business_name: "Sold To Name",
        approved: "Account Credited",
        edit: "Edit",
        file_url_data: "Proof Of Payment",
        download: "Download",
        sold_to: "Sold To",
        clear: "Clear",
        order_number: "Order number",
        payment: "Payment method",
        save: "Save",
        upload_images: "Upload Images",
        mode_of_payment: "Mode Of Payment",
        uploaded_date_to: "Uploaded date to",
      },
    },
    sap_digital_app_orders: {
      fields: {
        creation_date: "Order Date",
        business_id: "Sold To Name",
        user_id: "User Name",
        order_number: "Order number",
        business_site: "Ship To Name",
        mode_of_delivery: "Mode Of Delivery",
        customer_order_status_desc: "Order Status",
        products_manual: "(Ordered Qty/Dispatched Qty) Products",
        products: "(Ordered Qty) Products",
        load_nos: "Load nos",
        received: "Received",
        sap_plant: "Plant Name",
        sap_plant_id: "Plant Name",
        delivery_date_from: "Expected Date",
        delivery_date: "Delivery Date",
        customer_ref_number: "Local PO Note",
        contract_number: "Contract Number",
        truck_number: "Truck Number",
        driver_details: "Driver Details",
        delivery_address: "Delivery Address",
        sap_order_failed_message: "Order Pending Note",
        special_instructions: "Special instruction",
        mode_of_transport: "Mode of transport",
        vehicle_type: "Truck Type",
        orderDetails: "ORDER DETAILS",
        line_items: "LINE ITEMS",
        single_delivery: "SINGLE DELIVERIES",
        local_po_note: "Local purchase number",
        customer_order_status: "Customer order status",
        digital_order: "Digital Orders",
        is_app_order: "Is App Order",
        on_hold: "On Hold",
        shipment_number: "Shipment number",
        load_number: "Load number",
        product: "Product",
        ordered_quantity: "Ordered quantity",
        create_delivery: "CREATE A SINGLE DELIVERY",
        order_date_from: "Order date from",
        order_date_to: "Order date to",
        site_opening: "Your site opening time",
        site_closing: "Your site closing time",
        area: "Dispatch",
        delivery_window: "Delivery Window",
      },
    },
    sap_digital_order_line_items: {
      fields: {
        // product_master:'Product Name',
        material_no: "Product Code",
        quantity: "Quantity",
        input_uom_name: "UOM",
        product_master: {
          name: "Product Name",
        },
      },
    },
    sap_sdo_for_orders: {
      fields: {
        edit: "Edit",
        delivery_number: "Delivery Number",
        shipment_number: "Shipment Number",
        load_number: "Loading Number",
        order_status_description: "Status",
        loading_date: "Loading date",
        lsd_order_no: "Delivery Note",
        receive_full_order: "Received",
        received_date: "Received date",
        created_at: "Disputed Time",
      },
    },
    sap_digital_disputed_orders: {
      fields: {
        creation_date: "Order Date",
        business_id: "Sold To Name",
        user_id: "User Name",
        order_number: "Order number",
        business_site: "Ship To Name",
        mode_of_delivery: "Mode Of Delivery",
        customer_order_status_desc: "Order Status",
        products_manual: "(Ordered Qty/Dispatched Qty) Products",
        products: "(Ordered Qty) Products",
        load_nos: "Load nos",
        received: "Received",
        sap_plant: "Plant Name",
        delivery_date_from: "Expected Date",
        customer_ref_number: "Local PO Note",
        contract_number: "Contract Number",
        truck_number: "Truck Number",
        driver_details: "Driver Details",
        delivery_address: "Delivery Address",
        sap_order_failed_message: "Order Pending Note",
        special_instructions: "Special instruction",
        mode_of_transport: "Mode of transport",
        vehicle_type: "Truck Type",
        is_app_order: "Is App Order",
        on_hold: "On Hold",
        shipment_number: "Shipment number",
        load_number: "Load number",
        product: "Product",
        ordered_quantity: "Ordered quantity",
        sap_plant_id: "Plant Name",
        customer_order_status: "Customer order status",
        order_date_from: "Order date from",
        order_date_to: "Order date to",
      },
    },
    received_digital_orders: {
      fields: {
        creation_date: "Order Date",
        business_id: "Sold To Name",
        user_id: "User Name",
        order_number: "Order number",
        business_site: "Ship To Name",
        mode_of_delivery: "Mode Of Delivery",
        customer_order_status_desc: "Order Status",
        products_manual: "(Ordered Qty/Dispatched Qty) Products",
        products: "(Ordered Qty) Products",
        load_nos: "Load nos",
        received: "Received",
        sap_plant: "Plant Name",
        delivery_date_from: "Expected Date",
        customer_ref_number: "Local PO Note",
        contract_number: "Contract Number",
        truck_number: "Truck Number",
        driver_details: "Driver Details",
        delivery_address: "Delivery Address",
        sap_order_failed_message: "Order Pending Note",
        special_instructions: "Special instruction",
        mode_of_transport: "Mode of transport",
        vehicle_type: "Truck Type",
      },
    },
    change_log: {
      fields: {
        updateBy: "Updated by",
        updated_on: "Updated date",
        name: "Name",
        email: "Email",
        status: "Status",
        userRole: "User Role",
      },
    },
    track_trems_logs_history: {
      fields: {
        language_name: "Language name",
        updated_by: "Updated by",
        updated_at: "Updated date",
      },
    },
    create_business_from_csv: {
      fields: {
        create_business: "Create Business",
        upload_file: "Upload File",
        file_type: "File type must be .csv",
        file_size: "File size must be less than 10 MB",
        instruction: "Instructions",
        csv_file: "Only CSV files are allowed.",
        file_size_inst: "File size should be less than 2 MB.",
        wait_msg:
          "Please wait for the file upload to complete and for the confirmation message to appear before moving away from this page.",
        result_msg:
          "You will receive the results of the upload via email indicating how many records were added, updated and failed (if any).",
        get_format: "To get upload file format.",
        click_here: "Click here",
        to_download: " to download",
        save: "Save",
      },
    },
    send_sms_bulk_notifications: {
      fields: {
        message_purpose: "Message Purpose",
        enter_purpose: "Please enter a Purpose",
        upload_file: "Upload File",
        choose_valid_file: "Choose Valid file",
        instruction: "Instructions :",
        only_csv: "Only CSV files are allowed with Comma as separator.",
        get_format: "To get upload file format.",
        click_here: "Click here",
        to_download: " to download",
        csv_result: "CSV Result",
        retailer_found: "retailers found,",
        retailer_unregister: "retailers unregistered.",
        total_cost: "total cost :",
        sold_to_id: "Sold To Id",
        name: "Name",
        message_count: "Message Count",
        description: "Description",
        save: "Save",
        are_you_sure: "Are you sure, you want to proceed ?",
        cancel: "Cancel",
        ok: "Ok",
        success: "Successfully Created",
        purpose: "Purpose",
        target_type: "Target type",
        created_at: "Created at",
        send_bulk_message: "Send Bulk Message",
        details: "DETAILS",
        sold_list: "SOLD TO LIST",
        admin_name: "Creator Name",
        admin_email: "Creator Email",
        created_at: "Created at",
        sms_text: "Description",
        targeted_businesses_count: "Count of targeted retailers",
        notified_businesses_count: "Count of retailers notified",
        notification_read_count: "Count of retailers who have read",
        send_status_percent: "Completion %",
        name: "Sold To Name",
        phone: "Sold To Phone",
        send_status: "SMS status",
        send_response: "SMS response",
        job_status: "Message Progress",
        bulk_msg_details: "Bulk Message Details",
        uploaded_date_from: "Uploaded date from",
        uploaded_date_to: "Uploaded date to",
      },
    },
    my_menu: {
      fields: {
        dashboard: "Dashboard",
        admin: "Admin",
        whitelist_user: "Whitelist Users",
        terms: "Terms & Conditions",
        create_business: "Create Business",
        users: "Users",
        sold_to: "Sold Tos",
        clickit_user: "Users",
        digital_order: "Digital Orders",
        dispute_digital_order: "Dispute Digital Orders",
        received_digital_orders: "Received Digital Orders",
        proof_of_payments: "Proof of Payment",
        proof_records: "Proof Records",
        home_banner: "Home Banner",
        emailer_banner: "Emailer Banner",
        emailer_banner_list: "Emailer Banner List",
        mobile_banner_list: "Mobile Banner List",
        web_banner_list: "Web Banner List",
        product_image: "Product Image",
        product_inmage_list: "Product Image List",
        clickit_products: "Clickit Products",
        holcim_products: "HOLCIM+ Products",
        image_list: "Image List",
        contact_us: "Contact Us",
        in_app_message: "In app messages",
        bulk_in_app_messages: "Bulk In app messages",
        marketing: "Marketing",
        send_msg: "Send message",
        send_bulk_message: "Send bulk message",
        welcome_msg: "Welcome to Clickit admin dashboard",
        welcome_msg_holcim: "Welcome to HOLCIM+ admin dashboard",
        notification: "Notification",
        loyalty_points: "Loyalty Points",
        rewards_list: "Rewards List",
      },
    },
    user_loyalty_points: {
      fields: {
        loyalty_points: "Loyalty Points",
        award_redeem_loyalty_points: "Award/Redeem Loyalty Points",
        select_action: "Select Action",
        enter_select_action: "Enter Select Action",
        clickit_user: "Clickit User",
        holcim_user: "HOLCIM+ User",
        enter_clickit_user: "Enter Clickit User",
        enter_holcim_user: "Enter HOLCIM+ User",
        category_for_points_awarded_redeemed:
          "Category for points awarded/redeemed",
        comments_for_points_awarded_redeemed:
          "Comments for points awarded/redeemed",
        points_to_be_awarded_redeemed: "Points to be awarded/redeemed",
        enter_valid_points: "Enter Valid Points",
        enter_points_above_zero: "Enter Points Above 0",
        enter_points_below_thousand: "Enter Points Below 100000",
        enter_category: "Enter Category",
        enter_category_below_two_hundred_characters:
          "Enter Category Below 200 characters",
        enter_comments: "Enter Comments",
        enter_comments_below_five_hundred_characters:
          "Enter Comments Below 500 characters",
      },
    },
    loyalty_rewards: {
      fields: {
        rewards_list: "Rewards List",
        create_reward: "Create Reward",
        reward: "Reward",
        enter_reward: "Enter Reward",
        points: "Points",
        enter_valid_points: "Enter Valid Points",
        enter_points_above_zero: "Enter Points Above 0",
        save: "Save",
      },
    },
  },
};

export default englishMessages;
